import { useQuery } from '@tanstack/react-query';

import { QUERY_DEFAULTS } from '@/shared/lib/constants/api';
import { datasourceKeys } from '@/shared/lib/query/queryKeys';

import { getDataSourcesApi } from '@/entities/datasource/api';
import type { DataSourceListRequest } from '@/entities/datasource/domain/types';

type UseDataSourcesOptions = {
  enabled?: boolean;
};

export const useDataSources = (request: DataSourceListRequest, options?: UseDataSourcesOptions) => {
  return useQuery({
    queryKey: datasourceKeys.list(request),
    queryFn: () => getDataSourcesApi(request),
    enabled: options?.enabled ?? true,
    staleTime: QUERY_DEFAULTS.STALE_TIME.SHORT,
    gcTime: QUERY_DEFAULTS.GC_TIME.MEDIUM,
    retry: false,
  });
};
